import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { ThemeButton, useModalContext } from '../../../../ui'
import { getFormattedTime, dataToXLS } from '../../../../core/utils'
import {
  APPLICATION_TABLE_COLUMNS_KEY,
  APPS_TABLE_COLUMNS,
  GUILD_TABLE_COLUMNS,
} from '../../constants'
import { ExportNotEmptyDialog, ExportSomethingDialog } from '../dialogs'
import { useAjaxContext } from '../../../../core/ajax'
import { applicationDataPreparation } from '../../logics'

export const ExportToXLSBtn = () => {
  const intl = useIntl()
  const selectedRows = useSelector((state) => state.applications.selectedRows)
  const search = useSelector((state) => state.applications.search)
  const pagination = useSelector((state) => state.applications.pagination)
  const combos = useSelector((state) => state.combos)
  const userRole = useSelector((state) => state.global.role)
  const { get } = useAjaxContext()
  const {
    actions: { open },
  } = useModalContext()

  const [loading, setLoading] = useState(false)

  const exportUrl =
    userRole === 'gremio' ? '/solicitudes/tabla_gremios' : '/solicitudes/tabla_instaladores'
  const columns = userRole === 'gremio' ? GUILD_TABLE_COLUMNS : APPS_TABLE_COLUMNS

  const mainExport = async (data) => {
    const fileName = `solicitudes_${getFormattedTime()}.xlsx`
    await dataToXLS(data, columns, combos, intl, APPLICATION_TABLE_COLUMNS_KEY, fileName)
  }

  const handleExport = async () => {
    if (!selectedRows || !selectedRows.length) {
      open({ Component: ExportSomethingDialog })
      return
    }

    setLoading(true)
    try {
      await mainExport(selectedRows)
    } catch (error) {
      console.error('Error al exportar filas seleccionadas:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleExportAll = async () => {
    const { total_solicitudes } = pagination
    if (!total_solicitudes) {
      open({ Component: ExportNotEmptyDialog })
      return
    }

    setLoading(true)
    try {
      const { _num_x_pagina, _pagina, ...otherSearch } = search
      const { data } = await get(exportUrl, {
        params: { ...otherSearch, _num_x_pagina: total_solicitudes, _pagina: '1' },
      })
      const recievedData = applicationDataPreparation(columns, data.solicitudes, { intl })
      await mainExport(recievedData)
    } catch (error) {
      console.error('Error al exportar todos los datos:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ThemeButton
        color="primary"
        labelM="sm"
        onClick={handleExport}
        style={{ marginRight: '1em' }}
        loading={loading}
        disabled={loading}
      >
        {intl.formatMessage({ id: 'global.exportSelected' })} ({selectedRows.length})
      </ThemeButton>
      <ThemeButton
        color="primary"
        labelM="sm"
        loading={loading}
        onClick={handleExportAll}
        disabled={loading}
      >
        {intl.formatMessage({ id: 'global.exportAll' })}
      </ThemeButton>
    </>
  )
}
